var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55556 14.2222C2.55556 14.6348 2.71944 15.0304 3.01117 15.3222C3.30289 15.6139 3.69855 15.7778 4.11111 15.7778H11.8889C12.3014 15.7778 12.6971 15.6139 12.9888 15.3222C13.2806 15.0304 13.4444 14.6348 13.4444 14.2222V4.88889H14.7C14.8657 4.88889 15 4.75457 15 4.58889V3.63333C15 3.46765 14.8657 3.33333 14.7 3.33333H11.8889V1.77778C11.8889 1.36522 11.725 0.969556 11.4333 0.677833C11.1416 0.38611 10.7459 0.222221 10.3333 0.222221H5.66667C5.25411 0.222221 4.85845 0.38611 4.56672 0.677833C4.275 0.969556 4.11111 1.36522 4.11111 1.77778V3.33333H1.3C1.13431 3.33333 1 3.46765 1 3.63333V4.58889C1 4.75457 1.13431 4.88889 1.3 4.88889H2.55556V14.2222ZM5.66667 1.77778H10.3333V3.33333H5.66667V1.77778ZM4.88889 4.88889H11.8889V14.2222H4.11111V4.88889H4.88889Z",
    fill: "fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.66666H7.33333V12H6V6.66666ZM8.66667 6.66666H10V12H8.66667V6.66666Z",
    fill: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.10281a9be65a702d8c2fce88a3dce707.svg";
export { ForwardRef as ReactComponent };